import React, { Component } from "react";
import { Col, Row, Container } from "reactstrap";
import { joinCss } from "../../helpers/utils";

import appClasses from "../../App.module.scss";
import classes from "./ResultText.module.scss";

class ResultText extends Component {
  render() {
    const result = this.props.result;
    const dataArr =
      result.highlight["data.melingo"] != undefined
        ? result.highlight["data.melingo"]
        : result.highlight["data.raw"];
    const title = this.props.displayPageOnly
      ? "עמוד " + result.hit.page
      : result.hit.chapterIdForName +
        " | " +
        result.hit.chapterName +
        " - עמוד " +
        result.hit.page;
    return (
      <Container>
        <Row>
          <Col className={appClasses.chapterText}>
            <div>{title}</div>
          </Col>
        </Row>
        <Row>
          <Col className={joinCss(classes.fileText, "my-3")}>
            <div
              dangerouslySetInnerHTML={{
                __html: dataArr[0]
              }}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default ResultText;
